import React, { useState } from 'react';
import { useSettings } from '../context/SettingsContext';

const Contact = () => {
  const { settings } = useSettings();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: `
        .contact-hero { position: relative; overflow: hidden; background: linear-gradient(180deg, #080c14 0%, #0d1220 40%, #111827 100%); }
        .contact-hero::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 600px 400px at 50% 0%, rgba(255,215,0,0.07), transparent 70%), radial-gradient(ellipse 300px 300px at 85% 50%, rgba(255,215,0,0.04), transparent 70%); pointer-events: none; }
        .contact-hero-inner { position: relative; z-index: 1; }

        .contact-hero-badge { display: inline-flex; align-items: center; gap: 8px; background: rgba(255,215,0,0.1); border: 1px solid rgba(255,215,0,0.2); border-radius: 50px; padding: 6px 16px; font-size: 13px; color: var(--accent); font-weight: 600; margin-bottom: 16px; animation: cBadgeIn 0.6s ease; }
        @keyframes cBadgeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }

        .contact-hero-title { font-size: clamp(2rem, 4vw, 3.5rem); font-weight: 900; color: #fff; margin: 0 0 12px; line-height: 1.2; animation: cTitleIn 0.7s ease; }
        .contact-hero-title span { background: linear-gradient(135deg, var(--accent), #e6c200); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        @keyframes cTitleIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

        .contact-hero-subtitle { font-size: clamp(0.9rem, 1.5vw, 1.1rem); color: rgba(255,255,255,0.6); margin: 0 auto 20px; max-width: 500px; line-height: 1.6; animation: cSubIn 0.8s ease; }
        @keyframes cSubIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

        .contact-hero-cards { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; max-width: 480px; margin: 0 auto 20px; animation: cCardsIn 0.9s ease; }
        @keyframes cCardsIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
        .contact-hero-card { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; padding: 16px; text-align: center; transition: all 0.3s ease; text-decoration: none; display: block; }
        .contact-hero-card:hover { background: rgba(255,215,0,0.06); border-color: rgba(255,215,0,0.2); transform: translateY(-3px); box-shadow: 0 8px 24px rgba(0,0,0,0.3); }
        .contact-hero-card-icon { width: 40px; height: 40px; border-radius: 12px; background: linear-gradient(135deg, var(--accent), #e6c200); display: flex; align-items: center; justify-content: center; margin: 0 auto 10px; font-size: 18px; color: #000; font-weight: 700; }
        .contact-hero-card-title { font-size: 0.8rem; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; font-weight: 600; }
        .contact-hero-card-val { font-size: 0.95rem; color: #fff; font-weight: 700; word-break: break-all; }

        .contact-form-group { margin-bottom: 16px; }
        .contact-form-group label { display: block; color: rgba(255,255,255,0.7); font-size: 0.85rem; font-weight: 600; margin-bottom: 6px; }
        .contact-form-group input, .contact-form-group select, .contact-form-group textarea { 
          width: 100%; padding: 12px 14px; border-radius: 12px; background: rgba(0,0,0,0.3); 
          border: 1px solid rgba(255,255,255,0.12); color: #fff; font-size: 14px; 
          transition: all 0.3s; box-sizing: border-box; font-family: inherit;
        }
        .contact-form-group input:focus, .contact-form-group select:focus, .contact-form-group textarea:focus { 
          outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(255,215,0,0.08); 
        }
        .contact-form-group textarea { resize: vertical; min-height: 120px; }
        .contact-form-group select option { background: #111; color: #fff; }
        .contact-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .contact-submit-btn { width: 100%; padding: 14px; border-radius: 14px; background: linear-gradient(135deg, var(--accent), #e6c200); color: #000; font-size: 15px; font-weight: 700; border: none; cursor: pointer; transition: all 0.3s; margin-top: 8px; }
        .contact-submit-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(255,215,0,0.3); }

        @media (max-width: 768px) {
          .contact-form-row { grid-template-columns: 1fr; }
          .contact-hero-cards { grid-template-columns: repeat(2, 1fr); gap: 10px; max-width: 100%; }
          .contact-hero-card { padding: 14px 10px; }
          .contact-hero-card-val { font-size: 0.85rem; }
        }
      ` }} />

      {/* Hero */}
      <section className="contact-hero">
        <div className="container contact-hero-inner">
          <div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '30px' }}>
            <div className="contact-hero-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              We're Here to Help
            </div>
            <h1 className="contact-hero-title">Get In <span>Touch</span></h1>
            <p className="contact-hero-subtitle">Have questions about our products or need a custom lighting solution? Reach out — our experts are ready to assist.</p>

            <div className="contact-hero-cards">
              <a href={`tel:${settings?.phone || '7404704959'}`} className="contact-hero-card">
                <div className="contact-hero-card-icon">☎</div>
                <div className="contact-hero-card-title">Phone</div>
                <div className="contact-hero-card-val">{settings?.phone || '7404704959'}</div>
              </a>
              <a href={`mailto:${settings?.email || 'Factoelectricals@gmail.com'}`} className="contact-hero-card">
                <div className="contact-hero-card-icon">✉</div>
                <div className="contact-hero-card-title">Email</div>
                <div className="contact-hero-card-val">{settings?.email || 'Factoelectricals@gmail.com'}</div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-hero">
        <div className="container contact-hero-inner">
          <div style={{ maxWidth: '700px', margin: '0 auto', paddingTop: '40px', paddingBottom: '50px' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <h2 style={{ color: '#fff', fontSize: '2rem', fontWeight: 800, margin: '0 0 8px' }}>Send Us a <span style={{ color: 'var(--accent)' }}>Message</span></h2>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.95rem', margin: 0 }}>Fill out the form below and we'll get back to you within 24 hours</p>
            </div>
            
            <form onSubmit={handleSubmit} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '18px', padding: '32px' }}>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label>Full Name *</label>
                  <input type="text" name="name" value={formData.name} onChange={handleInputChange} placeholder="John Doe" required />
                </div>
                <div className="contact-form-group">
                  <label>Email Address *</label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="john@example.com" required />
                </div>
              </div>
              
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+91 98765 43210" required />
                </div>
                <div className="contact-form-group">
                  <label>Company Name</label>
                  <input type="text" name="company" value={formData.company} onChange={handleInputChange} placeholder="Your Company" />
                </div>
              </div>
              
              <div className="contact-form-group">
                <label>Subject *</label>
                <select name="subject" value={formData.subject} onChange={handleInputChange} required>
                  <option value="">Select Subject</option>
                  <option value="Product Inquiry">Product Inquiry</option>
                  <option value="Technical Support">Technical Support</option>
                  <option value="Sales">Sales Information</option>
                  <option value="Partnership">Partnership Opportunity</option>
                  <option value="Feedback">Feedback</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              
              <div className="contact-form-group">
                <label>Message *</label>
                <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Tell us about your requirements..." required></textarea>
              </div>
              
              <button type="submit" className="contact-submit-btn">Send Message</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
